import { ILead } from 'src/interfaces/lead';
import { IStore } from 'src/interfaces/store';
import {
    isChannelsModeArea,
    resolveConversationChannel,
    TChannelConversationRecord,
    TResolvedChannel,
    toChannelConversation,
} from 'src/modules/conversations/channels';
import { getLeadStoreArea, getLeadStoreAreaName } from './getLeadStoreArea';

/**
 * Channel capabilities of the lead's conversation (or of WhatsApp if it has none).
 * Areas in `channels` mode use the lead's `WarboxConversation` (OmniChannel);
 * `lead.conversation` is the legacy one and does not apply to them.
 */
export const resolveLeadChannel = (
    lead: ILead,
    channelConversation: TChannelConversationRecord | null = null,
    now: Date = new Date()
): TResolvedChannel =>
    resolveConversationChannel({
        conversation: isChannelsModeArea(getLeadStoreArea(lead))
            ? toChannelConversation(channelConversation)
            : lead.conversation || null,
        store: lead.store as Partial<IStore>,
        areaName: getLeadStoreAreaName(lead),
        now,
    });
